/* eslint-disable max-lines */

import { photoUrlBase } from 'constants/common';

const captionText =
	'Внимание! Услуга платная и предоставляется для материалов и изделий, приобретённых только в магазинах Лемана\u00A0ПРО. Стоимость\u00A0рассчитывается после консультации в магазине Лемана\u00A0ПРО, с учётом размеров и типа изделия.\n' +
	'Данные о ценах и наличии услуг могут отличаться. Пожалуйста, уточняйте точную стоимость и наличие услуг в магазинах.\n' +
	'Приобретаемые товары с оказанными услугами колеровки, резки стекла и дерева, пошива, оверлока в соответствии с Постановлением Правительства РФ №2463 от 31.12.2020, обмену и возврату не подлежат.\n' +
	'Пожалуйста, будьте внимательны при выборе.';

const peresadkaCaption =
	'Внимание! Услуга платная и предоставляется для растений и материалов, приобретённых только в магазинах Лемана ПРО.\n' +
	'Стоимость рассчитывается после консультации в магазине с учетом размера растения, типа кашпо и сложности работы.\n' +
	'Данные о ценах и наличии услуг могут отличаться.\n' +
	'Пожалуйста, уточняйте точную стоимость и наличие услуги в выбранном магазине.\n' +
	'Растения, пересаженные нашими специалистами, возврату и обмену не подлежат. Пожалуйста, будьте внимательны при выборе.';

export const Texts = {
	// analizVody
	2133: {
		smallText: [
			'Анализ воды поможет быстро определить качество воды и найти все вредные примеси, чтобы выбрать нужную систему фильтрации.',
		],
		reasons: {
			description:
				'Закажите анализ воды, если в вашей квартире или загородном доме есть проблемы с водой:',
			listItems: [
				'Неприятный запах',
				'Накипь',
				'Рыжие хлопья в воде',
				'Желтоватые или рыжие подтеки на сантехнике',
				'Наличие нитратов, нитритов в воде/в почве',
			],
		},
		servicesTitle: 'Сколько стоит анализ воды',
		steps: {
			title: 'Как заказать анализ воды',
			categoryPhotoUrl: `${photoUrlBase}/HLsWNitr102ueuuRNgfr8w/services-platform-instore-landing-analiz-vody.jpg`,
			listItems: [
				'Принесите пробу в магазин, где есть услуга анализа воды',
				'Передайте пробу сотруднику отдела «Водоснабжение»',
				'Оплатите услугу анализа воды на кассе и получите результат в течение часа или быстрее',
				'По результатам анализа сотрудник поможет подобрать необходимую систему фильтрации',
			],
		},
		benefits: {
			title: 'Какую воду можно принести на анализ?',
			listItems: [
				'Водопроводную, чтобы подобрать фильтр для квартиры',
				'После фильтра, чтобы убедиться в результатах работы системы очистки',
				'Из скважины или колодца, чтобы подобрать фильтр в вашем загородном доме или на даче',
				'Бутилированную',
			],
		},
		caption: null,
		schedule: {
			selected:
				'График работы лаборанта в магазине для анализа воды соответствует графику работы магазина',
			default:
				'График работы лаборанта в магазине для анализа воды можно узнать после выбора магазина',
		},
	},
	// kolerovka
	2134: {
		smallText: [
			'Воспользуйтесь колеровкой в Лемана\u00A0ПРО, чтобы придать краске индивидуальный оттенок. Мы колеруем краску для стен, потолков, обоев, дерева, металла и фасадов в любые оттенки из широкой палитры. Заколеровать также можно декоративную и фасадную штукатурку.\n' +
				'При покупке краски для колеровки обратите внимание на обозначение базы на банке. Белая краска (база А) рекомендована для колеровки в пастельные цвета, а прозрачная (база С) подойдёт для колеровки в яркие и насыщенные цвета.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит колеровка',
		steps: {
			title: 'Как заказать колеровку',
			categoryPhotoUrl: `${photoUrlBase}/4wifkOp7kkKrsofiabrofQ/services-platform-instore-landing-kolerovka.jpg`,
			listItems: [
				'Выберите товар в магазине',
				'Обратитесь к сотруднику колеровочного центра',
				'Выберите подходящий оттенок',
				'Оплатите товар и услугу колеровки на кассе',
				'Получите заколерованный товар',
			],
		},
		benefits: {
			title: 'Преимущества колеровки в Лемана\u00A0ПРО',
			listItems: [
				'Любой оттенок за несколько минут',
				'Широкая палитра цветов',
				'Возможность точно повторить оттенок, если нужно докупить краску. Рекомендуем приобретать краски из одной партии',
			],
		},
		caption:
			'Внимание! Услуга платная и предоставляется для товаров, приобретённых только в магазинах Лемана\u00A0ПРО. Стоимость рассчитывается после консультации в магазине Лемана\u00A0ПРО. Данные о ценах, наличии услуги и доступности колорантов могут отличаться. Пожалуйста, уточняйте актуальную информацию в магазине.\n' +
			'Приобретаемые товары с оказанными услугами колеровки, резки стекла и дерева, пошива, оверлока в соответствии с Постановлением Правительства РФ №2463 от 31.12.2020, обмену и возврату не подлежат.\n' +
			'Пожалуйста, будьте внимательны при выборе.',
		schedule: {
			selected:
				'График работы сотрудника колеровочного центра соответствует графику работы магазина',
			default:
				'График работы сотрудника колеровочного центра можно узнать после выбора магазина',
		},
	},
	// overlok
	2135: {
		smallText: [
			'Если вы хотите придать законченный вид ковролину и продлить срок его службы, вам подойдёт обработка оверлоком. Мы выполним оверлок купленных у нас ковровых дорожек и ковролина. Сотрудники отдела напольных покрытий профессионально обработают ковровые изделия по вашим индивидуальным размерам и дизайну.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит оверлок',
		steps: {
			title: 'Как заказать оверлок',
			categoryPhotoUrl: `${photoUrlBase}/3Wvf_pcp0k2-jhNtxJJ9Uw/services-platform-instore-landing-overlok.jpg`,
			listItems: [
				'Выберите товар в магазине и обратитесь в отдел «Напольные покрытия»',
				'Вместе с сотрудником отдела уточните параметры: геометрию, площадь, цвет ниток',
				'Оплатите товар и услугу на кассе магазина',
				'Получите товар с оверлоком',
			],
		},
		benefits: null,
		caption:
			'Внимание! Услуга платная и предоставляется для ковровых покрытий, приобретённых только в магазинах Лемана\u00A0ПРО. Стоимость рассчитывается после консультации в магазине Лемана\u00A0ПРО.\n' +
			'Данные о ценах и наличии услуги могут отличаться. Пожалуйста, уточняйте актуальную информацию в магазине.\n' +
			'Приобретаемые товары с оказанными услугами колеровки, резки стекла и дерева, пошива, оверлока в соответствии с Постановлением Правительства РФ №2463 от 31.12.2020, обмену и возврату не подлежат.\n' +
			'Пожалуйста, будьте внимательны при выборе.',
		schedule: {
			selected: 'График предоставления услуги оверлок соответствует графику работы магазина',
			default: 'График предоставления услуги оверлок можно узнать после выбора магазина',
		},
	},
	//poshivShtor
	2136: {
		smallText: [
			'Наши квалифицированные дизайнеры предложат индивидуальные решения пошива текстильных изделий, помогут подобрать ткань из широкого ассортимента в наличии и под заказ и подберут дополнительные аксессуары.',
			'Воспользуйтесь услугой индивидуального дизайна и пошива штор, покрывал, подушек и наволочек, чехлов для мебели и других текстильных изделий из тканей блэкаут, искусственной кожи, мебельной ткани, оксфорда, рогожки, гобелена, велюра, бархата и других.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит пошив штор',
		steps: {
			title: 'Как заказать пошив штор',
			categoryPhotoUrl: `${photoUrlBase}/O1Yql2pD8UmBCIxZz-vV5A/services-platform-instore-landing-poshiv-shtor.jpg`,
			listItems: [
				'Выберите товар в магазине и обратитесь в проектную зону «Пошив штор»',
				'Определитесь с услугой пошива и размерами',
				'Оплатите услугу и товар на кассе магазина',
				'Получите готовое изделие',
			],
		},
		benefits: null,
		caption:
			'Внимание! Услуга платная и предоставляется для тканей или готовых текстильных изделий, приобретённых только в магазинах Лемана\u00A0ПРО. Стоимость рассчитывается после консультации в магазине Лемана\u00A0ПРО с учётом размеров изделия.\n' +
			'Данные о ценах и наличии услуг могут отличаться, уточняйте актуальную информацию в магазине.\n' +
			'Приобретаемые товары с оказанными услугами колеровки, резки стекла и дерева, пошива, оверлока в соответствии с Постановлением Правительства РФ №2463 от 31.12.2020, обмену и возврату не подлежат.\n' +
			'Пожалуйста, будьте внимательны при выборе.',
		schedule: {
			selected:
				'График работы дизайнера по пошиву текстильных изделий соответствует графику работы магазина',
			default:
				'График работы дизайнера по пошиву текстильных изделий можно узнать после выбора магазина',
		},
	},
	// rezkaDereva
	2137: {
		smallText: [
			'У нас вы можете заказать качественный распил стройматериалов, деревянных и пластиковых изделий, а также листового материала. Работаем на современном оборудовании с высокой точностью.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит распил',
		steps: {
			title: 'Как заказать распил',
			categoryPhotoUrl: `${photoUrlBase}/B9LI_IYV0EKRD7PS4f8D4A/services-platform-instore-landing-rezka-dereva.jpg`,
			listItems: [
				'Выберите товар в магазине и обратитесь в центр резки дерева',
				'Определитесь с типом резки',
				'Получите распиленные материалы',
				'Оплатите услугу и товар на кассе магазина',
			],
		},
		benefits: {
			title: 'Преимущества распила в Лемана\u00A0ПРО',
			listItems: [
				'Точный распил по вашим размерам',
				'Экономия времени',
				'Удобная транспортировка материалов после распила',
			],
		},
		caption: captionText,
		schedule: {
			selected:
				'Режим работы специалиста центра резки дерева соответствует графику работы магазина',
			default:
				'Режим работы специалиста центра резки дерева можно узнать после выбора магазина',
		},
	},
	// rezkaStekla
	2138: {
		smallText: [
			'Мы предлагаем качественную резку стекла и зеркал по вашим размерам. Выполним резку стекла или зеркала нестандартной формы или размера. Работаем на современном оборудовании с высокой точностью.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит резка стекла',
		steps: {
			title: 'Как заказать резку стекла',
			categoryPhotoUrl: `${photoUrlBase}/COm8xNglDEiBaAtUem2mMw/services-platform-instore-landing-rezka-stekla.jpg`,
			listItems: [
				'Выберите товар в магазине и обратитесь в центр резки дерева и стекла с товаром',
				'Определитесь с размерами для резки',
				'Получите готовый товар',
				'Оплатите услугу и товар на кассе магазина',
			],
		},
		benefits: {
			title: 'Преимущества резки стекла в Лемана\u00A0ПРО',
			listItems: [
				'Точные отрезы по вашим размерам',
				'Экономия времени',
				'Удобная транспортировка материалов после резки',
			],
		},
		caption: captionText,
		schedule: {
			selected:
				'Режим работы специалиста центра резки стекла соответствует графику работы магазина',
			default:
				'Режим работы специалиста центра резки стекла можно узнать после выбора магазина',
		},
	},
	// podrezka
	3628: {
		smallText: [
			'Не подошла ширина? Не нужно искать новые рулонные шторы — мы профессионально подрежем готовые рулонные шторы под габариты вашего окна!',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит подрезка рулонных штор',
		steps: {
			title: 'Как заказать подрезку рулонных штор',
			categoryPhotoUrl: `https://cdn.lemanapro.ru/lmru/image/upload/v1755249219/fudzi/services-platform/services-landings/instore/podrezka-rulonnyh-shtor.png/podrezka-rulonnyh-shtor.png`,
			listItems: [
				'Выберите товар в магазине\u00A0и обратитесь в отдел «Отделочные материалы»',
				'Вместе с сотрудником отдела уточните ваши размеры окна',
				'Оплатите товар и услугу на кассе магазина или по ссылке',
				'Получите подрезанную рулонную штору по вашим размерам',
			],
		},
		benefits: {
			title: 'Преимущества подрезки рулонных штор в Лемана\u00A0ПРО',
			listItems: [
				'Точная подгонка без потери качества',
				'Быстро - часто готово в день обращения',
				'Сохранение всех функций — шторы работают как новые!',
			],
		},
		caption: captionText,
		schedule: {
			selected:
				'Режим работы специалиста центра подрезки штор соответствует графику работы магазина',
			default: 'График работы сотрудника можно узнать после выбора магазина',
		},
	},
	// rasteniya
	3681: {
		smallText: [
			'Купили новое растение? Мы поможем ему правильно освоиться в новом доме! Профессионально пересадим вашего зеленого питомца из транспортного горшка в свежий грунт и подходящее кашпо.',
		],
		reasons: null,
		servicesTitle: 'Сколько стоит пересадка комнатного растения',
		steps: {
			title: 'Как заказать пересадку комнатного растения',
			categoryPhotoUrl: `https://cdn.lemanapro.ru/lmru/image/upload/v1770824780/fudzi/services-platform/services-landings/instore/peresadka-komnatnyh-rasteniy.png/peresadka-komnatnyh-rasteniy.png`,
			listItems: [
				'Выберите растение или горшок в магазине и обратитесь в отдел «Садовый центр» или «Растения».',
				'Вместе с сотрудником отдела подберите оптимальный размер кашпо, дренаж и грунтокомпонентов, удобрения, средства для укоренения, подкормки и профилактики болезней.',
				'Оплатите товары и услугу на кассе магазина.',
				'Получите ваше растение, аккуратно и профессионально пересаженное.',
			],
		},
		benefits: {
			title: 'Преимущества пересадки растений в Лемана\u00A0ПРО',
			listItems: [
				'Индивидуальный подход: Мы составим грунт с учётом предпочтений выбранного растения.',
				'Здоровье растения: Предложим решения для быстрого укоренения, профилактики болезней и активного роста. Вы сможете выбрать только необходимые опции.',
				'Экспертная поддержка: Научим, как адаптировать растение и ухаживать за ним после пересадки на новом месте.',
			],
		},
		caption: peresadkaCaption,
		schedule: {
			selected:
				'Режим работы специалиста центра пересадки комнатных растений соответствует графику работы магазина',
			default: 'График работы сотрудника можно узнать после выбора магазина',
		},
	},
};
